import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import Hero from "./Hero";

const MaintenanceScreen = ({ title, message }) => (
  <div className="min-h-screen relative scanline-bg">
    <Hero minimal />
    <div className="relative z-30 mx-auto -mt-[420px] max-w-2xl px-4 pb-24 text-center">
      <div className="rounded-2xl border border-[#ffb84d]/30 bg-[#0f141b]/90 p-8 backdrop-blur">
        <div className="inline-flex items-center gap-2 rounded-full border border-[#ffb84d]/30 bg-[#ffb84d]/10 px-3 py-1 text-xs uppercase tracking-wider text-[#ffb84d]">
          🚧 Bauphase
        </div>
        <h1 className="mt-4 pixel-text text-2xl md:text-3xl text-white">{title}</h1>
        <p className="mt-4 text-sm md:text-base text-zinc-300">{message}</p>
      </div>
    </div>
  </div>
);

const MaintenanceGate = ({ children }) => {
  const { adminToken, ready } = useAuth();
  const [settings, setSettings] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      try { setSettings(await api.getSettings()); }
      finally { setLoaded(true); }
    })();
  }, []);

  if (!loaded || !ready) return null;
  // Maintenance-Mode: NUR /admin/login ist sichtbar fuer Nicht-Admins.
  // Eingeloggte User (kein Admin) sehen ebenfalls den Maintenance-Screen.
  const path = window.location.pathname;
  const isAdminLoginPath = path === "/admin/login" || path.startsWith("/admin/login/");
  if (settings?.maintenance_enabled && !adminToken && !isAdminLoginPath) {
    return <MaintenanceScreen title={settings.maintenance_title} message={settings.maintenance_message} />;
  }
  return children;
};

export default MaintenanceGate;
